<template lang="pug">
  el-row(
    type="flex",
    justify="space-between"
  )
    el-button(
      @click="$emit('cancel')",
      size="small"
    )
      b Cancelar

    el-button(
      :disabled="!textModel"
      type="success",
      @click="$emit('confirm')",
      size="small"
    )
      b {{textButtonConfirm}}
</template>

<script>
export default {

  props: {
    textModel: {
      type: String,
      default: ''
    },
    textButtonConfirm: {
      type: String,
      default: 'Utilizar'
    }
  }

}
</script>

<style scoped lang="scss">
  .icon {
    font-size: 14px;
  }

</style>



// WEBPACK FOOTER //
// src/screens/analise/components/AppUtilizarButtons.vue